var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guideBox"},[_c('img',{attrs:{"src":"/guide.png","alt":""},on:{"click":_vm.redemonstrate}})])
}
var staticRenderFns = []

export { render, staticRenderFns }